import Component from '../../../assets/scripts/modules/component'
import { hydratorRegisterComponent } from '../../../assets/scripts/utilities/hydrator'

class OptionFieldComponent extends Component {
  init () {
    this.errorDisplay = document.querySelector('.option-field__error')
    const optionFields = Array.from(this.element.querySelectorAll('.option-field__input'))
    this.checkField()
    optionFields.forEach(field => {
      field.addEventListener('change', () => this.checkField())
    })

    // Re-check visibility when validation errors appear or disappear on any text field
    window.addEventListener('form-error', () => this.checkField())

    // Use MutationObserver to detect when error class is removed from text fields
    const formRow = this.element.closest('form')
    if (formRow) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target
            if (target.classList.contains('text-field')) {
              // Error class may have been added or removed, re-check field visibility
              this.checkField()
              break
            }
          }
        }
      })
      observer.observe(formRow, { subtree: true, attributes: true, attributeFilter: ['class'] })
    }

    optionFields.forEach((field, idx) => {
      const errorId = `o${idx}`
      const errorMessage = field.getAttribute('data-invalid_message')
      if (!errorMessage) {
        return
      }
      field.addEventListener('valid', () => {
        this.removeError(errorId)
      })
      field.addEventListener('invalid', () => {
        this.addError(errorId, errorMessage)
      })
    })

    this.errors = []
  }

  hasValidationErrors (formRow) {
    // Check if this form-row or any of its fields have validation errors
    return formRow.querySelector('.text-field--error') !== null ||
           formRow.querySelector('[aria-invalid="true"]') !== null ||
           formRow.classList.contains('form-row--error')
  }

  getSubfieldForOption (subfieldGroupMap) {
    const formRow = document.querySelector(`.form-row#${subfieldGroupMap.controlsGroupId}`)
    if (!formRow) {
      return null
    }
    if (subfieldGroupMap.checked) {
      if (formRow) {
        if (formRow.getAttribute('data-required-on-open')) {
          const optionFieldRadio = formRow.querySelector('.option-field--radio')
          if (optionFieldRadio) {
            optionFieldRadio.classList.add('option-field--required')
          }
          formRow.querySelectorAll('input, select, textarea').forEach(input => {
            input.setAttribute('required', 'true')
          })
          formRow.querySelectorAll('.option-field__label, .text-field__label, .dropdown-field__label').forEach(label => {
            label.innerHTML = label.innerHTML.replace('(optioneel)', '')
          })
        }
        formRow.classList.remove('form-row--hidden')
      }
    } else {
      if (formRow) {
        if (formRow.getAttribute('data-required-on-open')) {
          const optionFieldRadio = formRow.querySelector('.option-field--radio')
          if (optionFieldRadio) {
            optionFieldRadio.classList.remove('option-field--required')
          }
          formRow.querySelectorAll('input, select, textarea').forEach(input => {
            input.removeAttribute('required')
          })
        }
        // Never hide rows that have validation errors, even if the option is unchecked
        if (!this.hasValidationErrors(formRow)) {
          formRow.classList.add('form-row--hidden')
        }
      }
    }

    if (!subfieldGroupMap.controlsGroupIds.length) {
      return
    }

    subfieldGroupMap.controlsGroupIds.forEach(controlsGroupId => {
      const optionSubField = document.querySelector(`.option-field__input[data-controls-group-id="${controlsGroupId}"]`)
      if (!optionSubField) {
        return
      }
      this.getSubfieldForOption({
        id: optionSubField.id,
        checked: subfieldGroupMap.checked && optionSubField.checked,
        controlsGroupId: controlsGroupId,
        controlsGroupIds: []
      })
    })
  }

  checkField () {
    const allFields = this.element.querySelectorAll(`.option-field__input`)
    const allFieldOptions = Array.from(allFields).map(otherField => {
      const groupIds = []

      groupIds.push(otherField.getAttribute('data-controls-group-id'))
      for (let i = 1; i < 10; i++) {
        const indexedGroupId = otherField.getAttribute(`data-controls-group-id-${i}`)
        if (indexedGroupId) {
          groupIds.push(indexedGroupId)
        } else {
          break
        }
      }

      if (groupIds.length > 0) {
        const complete = []
        groupIds.forEach(groupId => {
          let subControlsGoupIds = []
          if (document.querySelector(`.form-row#${groupId}`)) {
            const subfields = Array.from(document.querySelector(`.form-row#${groupId}`).querySelectorAll('.option-field__input'))
            const subIds = subfields.map(input => input.getAttribute('data-controls-group-id')).filter(id => id !== null)
            subControlsGoupIds = [...subControlsGoupIds, ...subIds]
            complete.push({
              id: otherField.id,
              checked: otherField.checked,
              controlsGroupIds: [...new Set(subControlsGoupIds)],
              controlsGroupId: groupId
            })
          }
        })
        return complete
      }
    })

    allFieldOptions.forEach(optionGroup => {
      optionGroup.forEach(option => {
        this.getSubfieldForOption(option)
      })
    })
  }

  addError (id, message) {
    this.errors.push([id, message])
    this.updateErrors()
  }

  removeError (id) {
    while (true) {
      const i = this.errors.findIndex(([i, _]) => i === id)
      if (i) {
        this.errors.splice(i, 1)
      } else {
        break
      }
    }
    this.updateErrors()
  }

  updateErrors () {
    if (!this.errorDisplay) {
      console.log('no error display')
      return
    }
    if (!this.errors.length) {
      this.element.classList.remove('option-field--error')
      this.errorDisplay.style.display = 'none'
      return
    }

    this.element.classList.add('option-field--error')
    this.errorDisplay.style.display = 'block'
    console.log(this.errors)
    this.errorDisplay.querySelector('span').innerText = this.errors.map(([_, m]) => m).join('; ')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.option-field').forEach(element => {
  element.instance = element.instance || new OptionFieldComponent(element)
}))
hydratorRegisterComponent('.text-field', OptionFieldComponent)
